import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-quantri-maubaocaoedit',
    templateUrl: './maubaocaoedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
    styleUrls: ['./maubaocaoedit.component.scss'],
    providers: [ListService, Repository]
})


export class maubaocaoeditComponent implements OnInit {

   
    
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    inputparents: any;
    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, FunctionId: null, ParentId: null, TemplatePath: null, FunctionImport: null, TableName: null, Report_ClassName: null, Report_Template:null};    
    nhomdtid:string=null;
    hoatdong: string = null;
    inputfunctions: any;

    @ViewChild('slChucNang',{static:false}) slChucNang: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        //return item.ma_Phan_He.toLowerCase().indexOf(term) > -1 || item.ten_Phan_He.toLowerCase().indexOf(term) > -1;
      return item.ten_Phan_He.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

  loadDataInit(nhomdoituongid: string, id: string, donviid: string, themmoi: number, row: any) {
    
          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            let data = JSON.parse(authlogin);
            var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
            this.inputfunctions = data.ds_quyen;
            
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
          }    

        this.nhomdtid = nhomdoituongid;
        //setTimeout(() => {
        //    this.mafocus.nativeElement.focus();  
        //},500);
   
       this.doituongSelect = { Id: null, FunctionId: null, ParentId: null, TemplatePath: null, FunctionImport: null, TableName: null, Report_ClassName: null, Report_Template:null };    
  
        if(id != null && row===null)
        {
         
          this.repo.getRequest("api/importexcel/getbyid/" + id)
            .subscribe(response => {
              this.doituongSelect.Id = id;
              this.doituongSelect.FunctionId = response.FunctionId;
              this.doituongSelect.ParentId = response.ParentId;
              this.doituongSelect.TemplatePath = response.TemplatePath;
              this.doituongSelect.FunctionImport = response.FunctionImport;
              this.doituongSelect.TableName = response.TableName;
              this.doituongSelect.Report_ClassName = response.Report_ClassName;
              this.doituongSelect.Report_Template = response.Report_Template;
            }); 
    }
    // trường hợp copy thì row!=null
    console.log("t11");
    console.log(row);
    if (row !== null) {
        
        this.doituongSelect.Id = null;
        this.doituongSelect.FunctionId =null;
        this.doituongSelect.ParentId = null;
        this.doituongSelect.TemplatePath = row.TemplatePath;
        this.doituongSelect.FunctionImport = row.FunctionImport;
        this.doituongSelect.TableName = row.TableName;
        this.doituongSelect.Report_ClassName = row.Report_ClassName;
        this.doituongSelect.Report_Template = row.Report_Template;
      }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            //this.slChucNang.focus();
            //event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
      if (this.doituongSelect.FunctionId == null || this.doituongSelect.FunctionId == "") {
            swal('Lỗi!', 'Vui lòng chọn chức năng!.', 'error');
            return;
      }
      if (this.doituongSelect.TemplatePath == null || this.doituongSelect.TemplatePath == "") {
        swal('Lỗi!', 'Vui lòng nhập đường dẫn file mẫu excel!.', 'error');
        return;
      }
      if (this.doituongSelect.FunctionImport == null || this.doituongSelect.FunctionImport == "") {
        swal('Lỗi!', 'Vui lòng nhập tên hàm c# thực thi nhập excel!.', 'error');
        return;
      }
      if (this.doituongSelect.TableName == null || this.doituongSelect.TableName == "") {
        swal('Lỗi!', 'Vui lòng nhập tên bảng trong CSDL!.', 'error');
        return;
      }

      this.repo.postRequest("api/importexcel/addorupdate",this.doituongSelect)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id=response;
                this.save.emit(this.doituongSelect);
            }); 
    }
   
    
   

   


}
